import { Component, Input } from '@angular/core';
import { DispatchBoxSummary } from '../../models/transfer-dispatchbox-allocation.model';
import { TpmItemsProcessorService } from '../../../../services/tpm-items-processor.service';

@Component({
  selector: 'app-details-canvas',
  standalone: false,
  templateUrl: './details-canvas.component.html',
  styleUrl: './details-canvas.component.css'
})
export class DetailsCanvasComponent {
  @Input() header: string = '';
  @Input() dispatchBoxSummary: DispatchBoxSummary=new DispatchBoxSummary();
  constructor(private readonly tpmItemsProcessorService: TpmItemsProcessorService,) { }

  getShortProductName(productName: string | null): string {
    return this.tpmItemsProcessorService.extractProductName(productName ?? '');
  }
}
